import { render, staticRenderFns } from "./order.vue?vue&type=template&id=66ffee02&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=66ffee02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ffee02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ffee02')) {
      api.createRecord('66ffee02', component.options)
    } else {
      api.reload('66ffee02', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=66ffee02&scoped=true&", function () {
      api.rerender('66ffee02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/beauty/order.vue"
export default component.exports